export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NewItemModal.vue?vue&type=template&id=09c51f52&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Index/NewItemModal.vue?vue&type=template&id=09c51f52&
// module id = null
// module chunks = 